export default "__VITE_ASSET__Bv9kpBZ9__"